__turbopack_context__.v({
  "logo": "Logo-module-scss-module__dIbJMq__logo",
  "logo__circles": "Logo-module-scss-module__dIbJMq__logo__circles",
  "logo__circles_circle": "Logo-module-scss-module__dIbJMq__logo__circles_circle",
  "logo__text": "Logo-module-scss-module__dIbJMq__logo__text",
});
